import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { SelectedPanelEnum } from '@app/core';
import { InsurancesQueryParamsInterface } from '@app/my-zone';
import {
    ErrorInterface,
    InsurancePolicyActionService,
    PolicyProductIdEnum,
    PolicyValidityStatusCodeEnum,
    PurchasedProductInterface,
} from 'outshared-lib';
import { CommonModule } from '@angular/common';
import { TooltipModule } from '@app/shared/tooltip/tooltip.module';
import { DateFormatPipeModule } from '@inshared/shared/util-pipes';
import { WucButtonModule } from '@inshared/website-ui-components';
import { IntersectionObserverService } from '@app/core/services/intersection-observer.service';

@Component({
    selector: 'ins-insurance-coverage-buttons',
    templateUrl: 'insurance-coverage-buttons.component.html',
    styleUrls: ['./insurance-coverage-buttons.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        TooltipModule,
        DateFormatPipeModule,
        WucButtonModule,
    ],
})
export class InsuranceCoverageButtonsComponent {
    @Input() public purchasedProduct!: PurchasedProductInterface;

    public productIdEnum: typeof PolicyProductIdEnum;
    public validityStatusCodeEnum: typeof PolicyValidityStatusCodeEnum;
    public errors: ErrorInterface[];
    public isDisabled: boolean;

    constructor(
        private insurancePolicyActionService: InsurancePolicyActionService,
        private router: Router,
        public intersectionObserverService: IntersectionObserverService,
        ) {
        this.productIdEnum = PolicyProductIdEnum;
        this.validityStatusCodeEnum = PolicyValidityStatusCodeEnum;
        this.errors = [];
        this.isDisabled = false;
    }

    public addCoverage(): void {
        const queryParams: InsurancesQueryParamsInterface = {
            panel: SelectedPanelEnum.InsuranceCoverage,
            productId: this.purchasedProduct.productId,
            productSequenceNumber: this.purchasedProduct.productSequenceNumber,
            scroll: true,
        };

        this.router.navigate([], {
            queryParams,
            queryParamsHandling: 'merge',
        });
    }

    public onCancelAddedCoverage(): void {
        this.insurancePolicyActionService
            .cancelAddedCoverage$({
                productId: this.purchasedProduct.productId,
                productSequenceNumber: this.purchasedProduct.productSequenceNumber,
            })
            .subscribe({
                next: () => this.cancelAddedCoverageSuccsss(),
                error: (errors) => this.cancelAddedCoverageError(errors),
            });

        this.errors = [];
        this.isDisabled = true;
    }

    private cancelAddedCoverageSuccsss(): void {
        this.isDisabled = false;
    }

    private cancelAddedCoverageError(errors: ErrorInterface[]): void {
        this.errors = errors;
        this.isDisabled = false;
    }
}
